import ContentLoader, { IContentLoaderProps } from 'react-content-loader';
import { variants } from './variants';

// Map your variants to pixel heights (adjust these values to match your CSS)
const variantHeights: Record<keyof typeof variants, number> = {
  lg: 25,
  md: 23,
  sm: 19,
  xs: 16,
  none: 18,
};

interface TextLoaderProps extends Omit<IContentLoaderProps, 'uniqueKey' | 'height' | 'width'> {
  variant?: keyof typeof variants;
  width?: number | string;
  className?: string;
  uniqueKey: string;
}

export const TextLoader = ({
  variant = 'md',
  width = '100%',
  className = '',
  uniqueKey,
  ...rest
}: TextLoaderProps) => {
  const height = variantHeights[variant];

  return (
    <ContentLoader
      width={width}
      height={height}
      className={className}
      style={{ width, height }}
      uniqueKey={uniqueKey}
      {...rest}
    >
      <rect x="0" y="0" rx={5} ry={5} width="100%" height={height} />
    </ContentLoader>
  );
};
